<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ 'app.likeable.add_categories_and_subcategories' | trans }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="card-content">
        <v-form>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                  :placeholder="'app.likeable.search_product' | trans"
                  v-model="search"
                  clearable
                  >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-treeview
                  :items="items"
                  :open.sync="open"
                  :multiple-active="true"
                  :selectable="true"
                  v-model="selected"
                  :filter="filter"
                  :search="search"
                  selected-color="#4caf50"
                  @input="filterActive()"
              >
                <template v-slot:prepend="{ item }">
                  <div :class="{hideCheckbox: shouldHideCheckbox(item)}"></div>
                  <v-icon
                      v-if="item.children"
                      v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"
                  ></v-icon>
                </template>
                <template v-slot:label="{ item }">
                  <span
                      :class="{
                        product: item.id.includes(TYPES.PRODUCT_TYPE) === true && item.id.includes(TYPES.PRODUCT_CATEGORY_TYPE) === false,
                        category: item.id.includes(TYPES.PRODUCT_CATEGORY_TYPE) === true,
                      }"
                  >
                    {{ item.name }}
                  </span>
                </template>
              </v-treeview>
            </v-flex>
          </v-layout>
        </v-form>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="save" :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {TYPES} from "../../../helpers/likeables";
import {mapGetters, mapActions} from "vuex";
import {trans} from "../../../app";
import {helpers} from "../../../helpers";

export default {
  data: function () {
    return {
      dialog: false,
      loading: false,
      open: [],
      items: [],
      selected: [],
      previouslySelected: [],
      approach: null,
      search: null,
      TYPES,
    };
  },
  created() {
    axios.get('/v2/likeables-nested').then(({data}) => {
      this.items = this.mapToItemsChildren(data.data)
          .sort((item1, item2) => item1.name.localeCompare(item2.name));
    });
  },
  methods: {
    ...mapActions(['fetchLikeables']),
    save() {
      this.loading = true;
      const data = this.selected.map(likeable => {
        const [type, id] = likeable.split('|');

        return {
          id,
          type,
        };
      }).filter(likeable => likeable.type === TYPES.PRODUCT_TYPE);

      axios.post(`/v2/patients/${this.patient.id}/likeables`, {likeables: data, approach: this.approach})
          .then(() => {
            this.fetchLikeables({patientId: this.patient.id});
            this.$toast.success(trans('app.saved'));
          })
          .catch(() => {
            this.$toast.error(trans('app.error_occurred'));
          });

      this.loading = false;
      this.close();
    },
    close() {
      this.dialog = false;
      this.open = [];
      this.search = '';
    },
    openModal(approach) {
      this.dialog = true;
      this.approach = approach;
      this.selected = this.likeables
          .filter(likeable => likeable.approach === approach)
          .map(likeable => `${likeable.type}|${likeable.likeable_id}`);
      this.previouslySelected = [...this.selected];
    },
    mapToItemsChildren(categories) {
      const mapItem = item => {
        const mappedItem = {
          id: `${TYPES.PRODUCT_CATEGORY_TYPE}|${item.id}`,
          name: item.name,
          children: [],
        };
        if (item.hasOwnProperty('subcategories')) {
          item.subcategories.forEach(subcategory => mappedItem.children.push(mapItem(subcategory)));
        }
        item.products.forEach(product => mappedItem.children.push({
          id: `${TYPES.PRODUCT_TYPE}|${product.id}`,
          name: product.name,
        }));

        return mappedItem;
      }

      return categories.map(mapItem);
    },
    shouldHideCheckbox(item) {
      if (!!this.search && item.hasOwnProperty('children')) {
        return item.children.length > 0;
      }

      return false;
    },
    filterActive: function () {
      return;
      if (this.selected.length > this.previouslySelected.length && !!this.search) {
        const search = this.search.toLowerCase();
        this.selected = this.selected.filter(selected => {
          if (selected.includes(this.TYPES.PRODUCT_CATEGORY_TYPE)) {
            return true;
          }
          if (this.previouslySelected.includes(selected)) {
            return true;
          }
          const name = this.getName(selected);

          return name !== null && name.toLowerCase().includes(search);
        });
      }
      this.previouslySelected = [...this.selected];
    },
    getName(id) {
      let items = helpers.deepClone(this.items);
      while (items.length > 0) {
        const item = items.pop();
        if (item.id === id) {
          return item.name;
        }
        if (item.hasOwnProperty('children')) {
          items = [...items, ...item.children];
        }
      }

      return null;
    },
  },
  computed: {
    ...mapGetters(['likeables', 'patient']),
    filter() {
      return (item, search) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      }
    },
  },
}
</script>

<style scoped>
  .card-content {
    height: 60vh;
    overflow-y: auto;
  }
  .product {
    font-style: italic;
  }
  .category {
    font-weight: bold;
  }
  .hideCheckbox {
    background-color: white;
    height: 20px;
    width: 20px;
    margin-left: -22px;
  }
</style>
